import { type Components, type Theme } from "@mui/material/styles";

export const tooltip: Components<Theme>["MuiTooltip"] = {
  defaultProps: {
    arrow: true,
    placement: "bottom",
    disableInteractive: true,
  },
  styleOverrides: {
    tooltip: ({ theme, ownerState }) => ({
      backgroundColor:
        ownerState.color === "error"
          ? theme.palette.error.main
          : theme.palette.gray?.[700],
      color: theme.palette.common.white,
      opacity: 0.9,
      borderRadius: 4,
      padding: "4px 8px",
      whiteSpace: "pre-line",
      fontSize: "10px",
      fontWeight: 500,
      lineHeight: "14px",
    }),
    arrow: ({ theme, ownerState }) => ({
      color:
        ownerState.color === "error"
          ? theme.palette.error.main
          : theme.palette.gray?.[700],
      opacity: 0.9,
    }),
  },
};
